export default "__VITE_ASSET__BCBNmtsf__"